import { FaceRetouchingOffSharp } from "@mui/icons-material";
import {
  Grid,
  Box,
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
  Autocomplete,
  TextField,
} from "@mui/material";
import { useEffect, useState } from "react";
import SubTitle from "../../app/components/SubTitle";
import Title from "../../app/components/Title";
import TitleSecondary from "../../app/components/TitleSecondary";
import { QueryLineItem } from "../../app/models/db";
import { useAppDispatch, useAppSelector } from "../../app/store/configureStore";
import {
  entrezDbSelectors,
  fetchSelectedDbDetailsAsync,
  updateSelectedDBState,
} from "../../app/store/entrezDbSlice";
import { entrezConfig } from "../../app/util/entrezConfig";
import { mergeNewQueryItem, queryTermFormatter } from "../../app/util/util";

//interface Props {
// dbDetails: DbWithState | undefined;
// onApply: (arg0: QueryLineItem) => void;
//}

export default function EntrezDBFieldsWithAutoComplete() {
  const { dbParams } = useAppSelector((state) => state.entrezDb);

  const dispatch = useAppDispatch();

  const selectedDbWithItsState = useAppSelector((state) =>
    entrezDbSelectors.selectById(state, dbParams.db)
  );

  //Load the fields for selected database
  useEffect(() => {
    console.log("useEffect of fields loading");
    if (!selectedDbWithItsState || !selectedDbWithItsState.fieldlist) {
      console.log(dbParams.db);
      console.log("loading fields on database selection changed");
      dispatch(fetchSelectedDbDetailsAsync());

      //load the auto complete from local storage on load for selected db
      var storedValues = localStorage.getItem(dbParams.db);
      if (storedValues) {
        var values = JSON.parse(storedValues);
        console.log(values);
        setOptionsForAutoComplete(values);
      }
    }
  }, [dbParams.db, dispatch]);

  //Load the auto complete options from local storage
  useEffect(() => {
    console.log("useEffect of auto complete options loading");
    //load the auto complete from local storage on load for selected db
    var storedValues = localStorage.getItem(dbParams.db);
    if (storedValues) {
      var values = JSON.parse(storedValues);
      console.log(values);
      setOptionsForAutoComplete(values);
    }
  }, [dbParams.db]);

  useEffect(() => {
    console.log("useEffect of default field value");
    if (
      selectedDbWithItsState &&
      selectedDbWithItsState.fieldlist &&
      selectedDbWithItsState.fieldlist.length > 0
    ) {
      setFieldName("ALL");
    }
  }, [selectedDbWithItsState!.fieldlist, dispatch]);

  const [searchTerm, setSearchTerm] = useState("");

  const [optionsForAutoComplete, setOptionsForAutoComplete] = useState<
    Array<string>
  >([]);

  const [operator, setOperator] = useState("");
  const [fieldName, setFieldName] = useState("");
  
  const handleSearchTermUpdate = (searchTerm: string) => {
    setSearchTerm(searchTerm);
  };

  const handleOperatorSelection = (event: SelectChangeEvent) => {
    setOperator(event.target.value);
  };

  const handleFieldSelection = (event: SelectChangeEvent) => {
    setFieldName(event.target.value);
  };

  const handleOnApply = () => {
    console.log("on Apply clicked");

    let fValue = fieldName;
    if (fValue === undefined || fValue === "")
      fValue = entrezConfig.FieldAsNone;

   // var fieldText =
   //   fValue === entrezConfig.FieldAsNone ? "" : "[" + fValue + "]";



      var fieldText =
      (fValue === entrezConfig.FieldAsNone || fValue === "ALL")
        ? ""
        : "[" + fValue + "]";




    var queryLineItem = {
      term: "(" + searchTerm + fieldText + ")",
      op: operator,
      field: fValue,
    };
    console.log(queryLineItem);
    
    handleApplyQueryLineItem(queryLineItem);

    //save term in autoComplete set;
    if (!optionsForAutoComplete.includes(searchTerm)) {
      if (optionsForAutoComplete.length >= 10) {
        optionsForAutoComplete.pop(); //remove element from last
      }

      var newOptions = [searchTerm, ...optionsForAutoComplete];
      setOptionsForAutoComplete(newOptions);
      localStorage.setItem(dbParams.db, JSON.stringify(newOptions));
    }
  };

  const handleApplyQueryLineItem = (query: QueryLineItem) => {
    console.log("Receive query line item");

    var queries = selectedDbWithItsState!.queryFields;

    //passing queries as new array, since queries is readonly
    const updatedQueries = mergeNewQueryItem([...queries], query);

    const formattedQueryTerm = queryTermFormatter(updatedQueries);
    //{ id: 'a', changes: { title: 'First (altered)' } }
    dispatch(
      updateSelectedDBState({
        id: dbParams.db,
        changes: {
          queryFields: updatedQueries,
          finalFormattedSearchTerm: formattedQueryTerm,
        },
      })
    );
  };

  const operators = entrezConfig.Operators;

  return (
    <>
      <Box display="flex" alignItems="center">
        {/* <Container maxWidth="lg"> */}
        <Grid container spacing={2}>
          <Grid item lg={1} md={2} sm={12} xs={12}>
            {/* Search Term - 1*/}
            <Box
              display="flex"
              flexDirection="column"
              alignItems="left"
              sx={{ ml: 1 }}
            >
              <Title>Database:</Title>
              <SubTitle color="secondary">
                {selectedDbWithItsState
                  ? selectedDbWithItsState.displayname
                  : "<Select>"}
              </SubTitle>
            </Box>
          </Grid>

          <Grid item lg={6} md={4} sm={12} xs={12}>
            {/* Search Term - 1*/}

            <Autocomplete
              id="free-solo-demo"
              freeSolo
              onInputChange={(event: any, text: string | null) => {
                console.log("On Input change - auto complete is:" + text);
                if (!text) {
                  return;
                }

                handleSearchTermUpdate(text);
              }}
              onChange={(event: any, text: string | null) => {
                console.log(
                  "On change - hanged value on auto complete is:" + text
                );
                if (!text) {
                  return;
                }

                handleSearchTermUpdate(text);
              }}
              value={searchTerm}
              // options={top100Films.map((option) => option.title)}
              options={optionsForAutoComplete}
              renderInput={(params) => (
                <TextField {...params} label="Search Term" />
              )}
            />

            {/* <SearchTerm
              onSearchTermChange={handleSearchTermUpdate}
            ></SearchTerm> */}
          </Grid>

          <Grid item lg={1} md={2} sm={6} xs={12}>
            {/* Operator selection - 2 */}
            <FormControl sx={{ width: "100%" }}>
              <InputLabel id="demo-OP-select-label">OP</InputLabel>
              <Select
                labelId="demo-OP-select-label"
                id="demo-OP-select"
                value={operator}
                label="OP"
                onChange={handleOperatorSelection}
              >
                <MenuItem value="">
                  <em>{entrezConfig.FieldAsNone}</em>
                </MenuItem>
                {operators.map((op) => (
                  <MenuItem key={op} value={op}>
                    {op}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>

          <Grid item lg={3} md={2} sm={6} xs={12}>
            {/* Field selection - 3 */}
            <FormControl sx={{ width: "100%" }}>
              <InputLabel id="demo-field-select-label">Field</InputLabel>
              <Select
                labelId="demo-field-select-label"
                id="demo-field-select"
                value={fieldName}
                label="Fields"
                onChange={handleFieldSelection}
              >
                {/* <MenuItem value="">
                  <em>None</em>
                </MenuItem> */}
                {selectedDbWithItsState &&
                  selectedDbWithItsState.fieldlist &&
                  selectedDbWithItsState.fieldlist.map(({ name, fullname }) => (
                    <MenuItem key={name} value={name}>
                      {fullname}
                    </MenuItem>
                  ))}
              </Select>
            </FormControl>
          </Grid>
          {/* fullWidth -4 */}

          <Grid item lg={1} md={2} sm={12} xs={12}>
            <Button
              disabled={
                searchTerm === "" ||
                typeof selectedDbWithItsState === "undefined"
              }
              onClick={handleOnApply}
              sx={{ height: "52px" }}
              color="primary"
              size="small"
              variant="contained"
            >
              Apply 
            </Button>
            {/* <span>{item.name}</span> */}
          </Grid>
          
        </Grid>

        {/* </Container> */}
      </Box>
    </>
  );
}

// {" "}
//                   &nbsp;{" "}
